/**
 * Value/label formatters used by KPIs, tooltips, and data labels.
 * Supports currency (Indian number system default), number, percent,
 * with optional prefix/suffix/decimals overrides.
 */

export function compactNumber(val) {
  const abs = Math.abs(val)
  if (abs >= 1e7)  return (val / 1e7).toFixed(2) + 'Cr'
  if (abs >= 1e5)  return (val / 1e5).toFixed(2) + 'L'
  if (abs >= 1e3)  return (val / 1e3).toFixed(1) + 'K'
  return Number.isInteger(val) ? String(val) : val.toFixed(1)
}

/** Y-axis tick formats: full | lakhs | crs | hcrs */
export function formatAxisTick(val, format) {
  const n = Number(val)
  if (!isFinite(n)) return String(val)
  const fmt = format || 'full'
  const trim = (s) => s.replace(/\.?0+$/, '')

  if (fmt === 'lakhs') return trim((n / 1e5).toFixed(2)) + ' L'
  if (fmt === 'crs') return trim((n / 1e7).toFixed(2)) + ' Cr'
  if (fmt === 'hcrs') return trim((n / 1e9).toFixed(2)) + ' HCr'

  if (Number.isInteger(n)) return n.toLocaleString('en-IN')
  return n.toLocaleString('en-IN', { maximumFractionDigits: 2 })
}

export function fmtValue(val, cfg) {
  cfg = cfg || {}
  const fmt = cfg.format || 'number'
  const prefix = cfg.prefix || ''
  const suffix = cfg.suffix || ''
  const decimals = cfg.decimals != null
    ? cfg.decimals
    : (fmt === 'currency' ? 0 : (Number.isInteger(val) ? 0 : 2))

  if (fmt === 'percent') {
    return prefix + (val * 100).toFixed(decimals) + '%' + suffix
  }

  let str
  const abs = Math.abs(val)
  if (abs >= 1e7)      str = (val / 1e7).toFixed(2) + 'Cr'
  else if (abs >= 1e5) str = (val / 1e5).toFixed(2) + 'L'
  else if (abs >= 1e3) str = val.toLocaleString('en-IN', { maximumFractionDigits: decimals })
  else                 str = val.toFixed(decimals)

  if (fmt === 'currency' && !prefix) return '₹' + str + suffix
  return prefix + str + suffix
}

export function escapeHtml(s) {
  if (s == null) return ''
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function downloadJson(obj, filename) {
  const blob = new Blob([JSON.stringify(obj, null, 2)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename || 'dashboard-config.json'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
